// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1323":"05cb845d","4262":"1cbfe442","6771":"65b714ff"}[chunkId] + ".chunk.css";
};